import { useNotification } from '@kyvg/vue3-notification'

export function getParsedValue(value) {
  value = String(value);

  if (!value || value === 'auto') {
    return 'auto';
  }

  if (value.includes('%')) {
    return Number(value.replace('%', '')) + '%';
  }

  return Number(value) + 'px';
}

export function cutString(string, startTo = 6, endFrom = 6) {
  if (!string || string.length < startTo + endFrom) {
    return string;
  }

  const start = string.slice(0, startTo);
  const end = string.slice(-endFrom);
  return `${start}...${end}`;
}

export function throttle(callback, delay = 250) {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  }
}

export function notify(type, text) {
  const { notify }  = useNotification()

  notify({ type, text })
}

export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }

    notify('success', 'Copied to the Clipboard')
  } catch (err) {
    console.error('Failed to copy: ', err)
    notify('error', 'Failed to copy to the Clipboard')
  }
}